import { render, staticRenderFns } from "./AssetsMaterialsSuppliersEdit.vue?vue&type=template&id=235b90ef&"
import script from "./AssetsMaterialsSuppliersEdit.vue?vue&type=script&lang=js&"
export * from "./AssetsMaterialsSuppliersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports